import React from "react";
import { Container } from "@mui/material";
import OrderTabs from "../Components/OrderComponents/OrderTabs";

const Order = () => {
  return (
    <Container maxWidth="lg">
      <OrderTabs />
    </Container>
  );
};

export default Order;
